export const defaultSelectedLicencia = () => {
    return {
        id_empresa: '',
        codigo: '',
        duracion_licencia: '',
        cantidad_usuarios: '',
        fecha_inicio_licencia: '',
        fecha_fin_licencia: '',
        usuario_contratista: 0,
        precio: '',
        multiusuario: 0,
        usuario_global: 0,
        afiliacion: '',
        observaciones: '',
    }
}

export default {
    selectedLicencia: defaultSelectedLicencia(),
    licencias: [],
    empresas: [],
    licenciaEmpresas: [],
    listadoHistorico: [],
    accion: 'crear',
    error: '',

    filtro: {
        buscar: '',
        page: 1,
        perPage: 15,
        sortBy: 'codigo',
        sort: 'DESC',
    },
    filtroEmpresa: {
        empresa: ''
    }

}